import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import AuthLayout from "../components/auth/AuthLayout";
import api, { formatApiError } from "../lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | success | error
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setErr("This link is missing a verification token."); return; }
    (async () => {
      try { await api.post("/api/auth/verify-email", { token }); setState("success"); }
      catch (e) { setErr(formatApiError(e)); setState("error"); }
    })();
  }, [token]);

  return (
    <AuthLayout title={state === "loading" ? "Verifying your email…" : state === "success" ? "Email verified" : "Verification failed"} testid="verify-email-page">
      {state === "loading" && <div className="flex justify-center py-6"><Loader2 size={32} className="animate-spin text-indigo2" /></div>}
      {state === "success" && (
        <div className="flex flex-col items-center text-center">
          <CheckCircle2 size={48} className="text-emerald2 mb-4" />
          <p className="t-body text-slate2 mb-6">Your email is now verified. You can sign in and start your 14-day free trial.</p>
          <Link to="/login" className="btn btn-primary btn-block" data-testid="verify-to-login">Sign in</Link>
        </div>
      )}
      {state === "error" && (
        <div className="flex flex-col items-center text-center">
          <AlertCircle size={48} className="text-rose2 mb-4" />
          <p className="t-body text-slate2 mb-6">{err}</p>
          <Link to="/login" className="btn btn-secondary btn-block">Back to sign in</Link>
        </div>
      )}
    </AuthLayout>
  );
}
